import { Card } from "@mui/material";
import { Accordion } from "react-bootstrap";
import styled from "styled-components";


export const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    align-items: start;
`